/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
// import { FirebaseMessagingService } from './common/services/firebase.service';
// import { ProfileService } from './common/services/profile.service';
import { UsersService } from './pages/users/users.service';
import { NetworkStatusNotifierService } from './common/services/network-status-notifier.service';
import { PwaUpdateService } from './common/services/pwa-update.service';
@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet><ngx-pwa-update-banner></ngx-pwa-update-banner>',
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    // private messagingService: FirebaseMessagingService,
    // private profileService: ProfileService,
    private usersService: UsersService,
    private networkStatusNotifier: NetworkStatusNotifierService,
    private pwaUpdateService: PwaUpdateService
  ) {}

  ngOnInit(): void {
    // this.messagingService.listen();

    // this.profileService.getUser().subscribe(async (profile) => {
    //   const token = await this.messagingService.requestPermission();
    //   const existedToken = (profile?.fcmTokens || []).find(
    //     (i) => i.token === token && i.os === this.getOS()
    //   );
    //   if (!existedToken && token) {
    //     this.updateFCMToken(profile.id, token);
    //   }
    // });

    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.networkStatusNotifier.init();
    this.pwaUpdateService.init();
  }

  updateFCMToken(userId: string, token: string) {
    const os = this.getOS();
    this.usersService
      .updateFCMToken(userId, {
        deviceId: os,
        os,
        token,
      })
      .subscribe((res) => {
        console.log(res);
      });
  }

  getOS() {
    if ((navigator as any).userAgentData) {
      return (navigator as any).userAgentData.platform;
    }
    return this.getOSFromUA();
  }

  getOSFromUA() {
    const ua = navigator.userAgent;

    if (/windows/i.test(ua)) return 'Windows';
    if (/android/i.test(ua)) return 'Android';
    if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
    if (/mac os/i.test(ua)) return 'MacOS';
    if (/linux/i.test(ua)) return 'Linux';

    return 'Unknown';
  }
}
